<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  overflow-x: hidden;
  overflow-y: hidden;
}
.content {
  background: rgba(248, 249, 254, 1);
  position: relative;
  min-height: 100vh;
}
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
/* loading加载样式 */
.el-loading-spinner .path {
  stroke: #000000!important;
}
.el-button {
  width: 100%;
}
/* scoller样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: none;
  background-color: #fff;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #000000;
}
:root {
  --menu-width: 260px;
  --nav-height: 74px;
  --right-width: 260px;
}
@media screen and (max-width: 1439px) {
  :root {
    --menu-width: 220px;
    --nav-height: 60px;
    --right-width: 0;
  }
}
.mainbox {
  position: absolute;
  bottom: 0;
  right: 0;
  width: calc(100% - var(--menu-width));
  height: calc(100% - var(--nav-height));
  /* animation: appear 0.6s;
  -webkit-animation: appear 0.6s; */
}
@keyframes appear {
  from {
    bottom: -100%;
  }
  to {
    bottom: -0%;
  }
}
@-webkit-keyframes appear {
  from {
    bottom: -100%;
  }
  to {
    bottom: -0%;
  }
}

.el-input__inner {
  height: 100%;
  line-height: 100%;
}

.el-input__icon {
  line-height: 32px;
}

.el-table th.el-table__cell > .cell {
  padding-left: 14px;
  padding-right: 14px;
}

.el-pagination {
  padding-top: 20px!important;
  padding-bottom: 20px!important;
  display: flex!important;
  justify-content: center!important;
  align-items: center!important;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  border: 1px solid rgba(0, 0, 0, 0.15)!important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #409eff;
}

.el-input .el-input__clear {
  font-size: 20px;
  line-height: 68px;
}

.el-input__suffix {
  right: 10px;
}

.el-input__inner {
  height: 100%;
}

.el-input {
    width: initial;
  }

  .el-form-item__label {
    display: flex;
    min-width: 6rem;
  }

  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    order: 2;
    margin-left: 4px;
  }

  .el-button+.el-button,
  .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0!important;
  }

  .el-upload {
    display: inline-flex;
    align-items: flex-end;
  }

  .el-textarea__inner:focus {
    border-color: #000000;
  }

  .el-textarea__inner {
    height: 150px;
    font-size: inherit!important;
    color: #606266;
    font-weight: 500;
    font-family:Arial;
  }

  .inlinetext .el-form-item__content {
    display: flex;
  }

  .inlineflextext {
    display: flex;
  }

  .inlineflextext .el-form-item__content {
    display: inline-flex;
  }

  .el-input__inner {
    width: 100%;
    height: 100%;
  }

  .el-input__inner:focus {
    border: 1px solid #000000;
  }

  .el-textarea {
    width: 540px;
  }

  .el-button:focus, .el-button:hover{
    color: #ffffff!important;
    border-color: #dcdfe6!important;
    background-color: #000000!important;
  }

  .forgetform-input .el-input__inner,.loginform-input .el-input__inner{
    height:100%!important;
    width: 100%!important;
  }
  .tablesearch-item .el-input .el-input__inner{
    height: 32px!important;
    line-height: 32px!important;
  }
  .tablesearch-item .el-input .el-input__suffix{
    display: flex;
    align-items: center;
  }
  .yuyueformitem .el-select{
    width: 540px;
  }
  .yuyueformitem .el-input{
    width: 540px;
    height: 40px;
  }
  .yuyueformitem .el-textarea{
    width: 540px;
  }
  .tableoplink{
    color: #1890ff!important;
    white-space: nowrap;
  }
  .el-radio__input.is-checked .el-radio__inner{
    border-color: #000000!important;
    background: #000000!important;
  }
  .el-radio__input.is-checked+.el-radio__label{
    color: #000000!important;
  }
  .flexbox{
    display: flex;
  }
  .el-popconfirm__action{
    display: flex;
    margin-top: 20px;
  }
  .el-message-box__btns{
    display: flex;
    justify-content: space-between;
  }
  .el-message-box__btns .el-button{
    width: calc((100% - 20px)/2);
  }
  .noticebadge{
    line-height: 1.6rem;
    padding-right: 20px;
  }
  .el-collapse-item__header{
    height: auto;
    padding: 10px 0;
  }
  .noticebadge .el-badge__content.is-fixed.is-dot{
    top: 6px;
    right: 16px;
  }
  .loadmore{
    height: 60px;
    line-height: 60px;
    text-align: center;
    width: 100%;
  }
  .disinline{
    display: inline-block;
  }
  .articledialog .el-dialog__body{
    padding-top: 10px;
  }
  .el-table--border::after, .el-table--group::after, .el-table::before{
    z-index: initial;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue